import PropTypes from 'prop-types';

import CategoryFilters from 'components/Category/Filters';

const SubcategorySidebarBottomSection = ({
  forwardedFiltersRef,
  gaEventCategory,
  offersFilters,
  stores,
  onOffersFiltersReset,
  onOffersPriceRangeFilterChange,
  onOffersStoresFilterChange,
  onOffersVenueFilterChange,
}) => (
  <div
    ref={forwardedFiltersRef}
    className="hidden flex-col items-start lg:flex"
  >
    <CategoryFilters
      gaEventCategory={gaEventCategory}
      offersFilters={offersFilters}
      stores={stores}
      onOffersFiltersReset={onOffersFiltersReset}
      onOffersPriceRangeFilterChange={onOffersPriceRangeFilterChange}
      onOffersStoresFilterChange={onOffersStoresFilterChange}
      onOffersVenueFilterChange={onOffersVenueFilterChange}
    />
  </div>
);

SubcategorySidebarBottomSection.propTypes = {
  forwardedFiltersRef: PropTypes.shape({ current: PropTypes.shape() }),
  gaEventCategory: PropTypes.string.isRequired,
  offersFilters: PropTypes.shape({
    priceRange: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }).isRequired,
    stores: PropTypes.arrayOf(
      PropTypes.shape({
        storeId: PropTypes.number.isRequired,
        storeName: PropTypes.string.isRequired,
      })
    ),
    venue: PropTypes.string,
  }).isRequired,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.number.isRequired,
      storeName: PropTypes.string.isRequired,
    })
  ).isRequired,
  onOffersFiltersReset: PropTypes.func.isRequired,
  onOffersPriceRangeFilterChange: PropTypes.func.isRequired,
  onOffersStoresFilterChange: PropTypes.func.isRequired,
  onOffersVenueFilterChange: PropTypes.func.isRequired,
};

export default SubcategorySidebarBottomSection;
